import { IMG } from "@/data/site";

export const NAV = [
  "Marketing & Eventos",
  "Producción Audiovisual",
  "Proyectos",
  "Actualidad",
];

export const HERO = {
  eyebrow: "Agencia + Estudio · Madrid",
  title: "Marcamos la diferencia",
  sub: "Marketing, comunicación y eventos. Producción audiovisual y contenidos de autor. Dos mundos, una misma visión.",
};

export const WORLDS = [
  {
    id: "audiovisual",
    label: "Cine & Documental",
    line: "Creamos historias en imágenes",
    desc: "Documentales, películas, series y programas de producción propia y coproducción.",
    image: IMG.filmmaker,
  },
  {
    id: "marketing",
    label: "Marketing & Resultados",
    line: "Datos que generan negocio",
    desc: "Estrategia, comunicación, eventos, gastronomía y fidelización medibles.",
    image: IMG.meeting,
  },
];

export const WORK = [
  { title: "El Viaje del Ganador", kicker: "Documental", image: IMG.evgHeader },
  { title: "En Reconstrucción", kicker: "Documental", image: IMG.desert },
  { title: "Member Get Member", kicker: "Fidelización", image: IMG.rMgm },
  { title: "American Express", kicker: "Experiencias", image: IMG.rAmexExp },
  { title: "Telefónica", kicker: "Formación 360°", image: IMG.rTelefonica },
  { title: "Marqués de Riscal", kicker: "Branded content", image: IMG.wine },
];

export const METRICS = [
  { value: "15", suffix: "", label: "Años de trayectoria" },
  { value: "40", suffix: "+", label: "Marcas y clientes" },
  { value: "1", suffix: "º", label: "Observatorio Referral de España" },
  { value: "360", suffix: "°", label: "Estrategia integral" },
];

export const NEWS = [
  {
    meta: "12/02/2024",
    title: "Grabarte lidera el primer Observatorio de Referral Marketing de España",
  },
  {
    meta: "Cine · Festivales",
    title: "«En Reconstrucción» se cuela en festivales internacionales de cine",
  },
  {
    meta: "Documental",
    title: "«El Viaje del Ganador» recorre el circuito internacional de festivales",
  },
];

export const CONTACT = {
  email: "info@grabarte360.com",
  phone: "+34 915 32 77 01",
  address: "Avenida Miguel Delibes, 32 · 28052 Madrid",
};

export const VARIANTS = [
  { route: "/v1", name: "Oscuro limpio", desc: "Cinematográfico y aireado sobre fondo oscuro." },
  { route: "/v2", name: "Claro editorial", desc: "Estilo revista, serif y mucho espacio en blanco." },
  { route: "/v3", name: "Mezcla claro/oscuro", desc: "Secciones alternas de alto contraste." },
];
